import Hero from "./Hero";
import WhyChooseUs from "./WhyChooseUs";
import Sectors from "./Sectors";
import Services from "./Services";
import Stats from "./Stats";
import PrestigiousClients from "./PrestigiousClients";
import Certifications from "./Certifications";
import CTABanner from "./CTABanner";

export default function Home() {
  return (
    <>
      <Hero />
      <Services />
      <WhyChooseUs />
      <Sectors />
      <PrestigiousClients />
      <Stats />
      <Certifications />
      <CTABanner />
    </>
  );
}
